import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/kvl-png.png";
import { Container } from "react-bootstrap";
import { PiListHeart } from "react-icons/pi";
import { LuPanelRightClose } from "react-icons/lu";
import { logout } from "../../store/slices/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  openBuyPlanModal,
  closeBuyPlanModal,
} from "../../store/slices/ui";

export default function UserHeaderNav() {
  const { profilelist = {} } = useSelector((state) => state.profile);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showCard, setShowCard] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const { showBuyPlanModal } = useSelector((state) => state.ui);

  const cardRef = useRef();

  // useEffect(() => {
  //   dispatch(getProfile());
  // }, [dispatch]);

  useEffect(() => {
    if (
      profilelist &&
      profilelist.aadhaarVerified === false &&
      window.location.pathname !== "/user/verify-aadhaar"
    ) {
      navigate("/user/verify-aadhaar", { replace: true });
    }
  }, [profilelist, navigate]);

  const hasActivePlan = profilelist?.hasActivePlan;

  const userName = profilelist?.name || "";
  const userEmail = profilelist?.email || "";
  const profilePhoto = profilelist?.profilePhoto || "";
  const firstLetter = userName?.charAt(0)?.toUpperCase();

  const handleNavClick = (path) => {

    if (!profilelist?.aadhaarVerified) {
      navigate("/user/verify-aadhaar");
      return;
    }

    const allowedWithoutPlan = [
      "/user/home",
      "/user/membership",
    ];

    if (!hasActivePlan && !allowedWithoutPlan.includes(path)) {
      dispatch(openBuyPlanModal());
      return;
    }

    dispatch(closeBuyPlanModal());
    navigate(path);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cardRef.current && !cardRef.current.contains(event.target)) {
        setShowCard(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  const handleLogout = async () => {
    await dispatch(logout());

    navigate("/", { replace: true });
  };

  return (
    <>
      <header className="header d-flex align-items-center">
        <Container className="d-flex justify-content-between align-items-center">
          {/* Logo */}
          <div className="d-flex align-items-center">
            <img
              src={logo}
              alt="logo"
              className="logo-img"
              onClick={() => navigate("/user/home")}
            />
            <div className="ms-2">
              <h5
                className="mb-0"
                style={{
                  color: "#7b1e3b",
                  fontWeight: "700",
                  fontFamily: "Georgia, 'Times New Roman', serif",
                  letterSpacing: "1px",
                  lineHeight: "1.1",
                }}
              >
                KVL Matrimony
              </h5>

              <small
                style={{
                  color: "#777",
                  fontSize: "11px",
                  letterSpacing: "1px",
                }}
              >
                TRUSTED LINGAYAT MATRIMONY
              </small>
            </div>
          </div>

          {/* Top Nav */}
          <div className="header-right-links d-flex align-items-center gap-3">
            <button
              className="right-link px-3 py-1"
              onClick={() => handleNavClick("/user/home")}
            >
              Home
            </button>

            <button
              className="right-link px-3 py-1"
              onClick={() => handleNavClick("/user/message")}
            >
              Message
            </button>

            <button
              className="right-link px-3 py-1"
              onClick={() => handleNavClick("/user/interests")}
            >
              Interests
            </button>

            <button
              className="right-link px-3 py-1"
              onClick={() => handleNavClick("/user/profile-search")}
            >
              Matches
            </button>

            <button
              className="right-link px-3 py-1"
              onClick={() => handleNavClick("/user/membership")}
            >
              Membership Plans
            </button>
          </div>

          {/* Profile */}
          <div className="d-flex align-items-center gap-3">
            <div className="position-relative rightside-profile" ref={cardRef}>
              <span
                className="matrimony-avatar"
                onClick={() => setShowCard((prev) => !prev)}
              >
                {profilePhoto ? (
                  <img
                    src={profilePhoto}
                    alt="profile"
                    className="avatar-img"
                  />
                ) : (
                  <span className="avatar-letter">{firstLetter}</span>
                )}
              </span>

              {showCard && (
                <div className="profiledrop-dropdown">
                  <div className="profiledrop-top">
                    <span className="matrimony-avatar">
                      {profilePhoto ? (
                        <img
                          src={profilePhoto}
                          alt="profile"
                          className="avatar-img"
                        />
                      ) : (
                        <span className="avatar-letter">{firstLetter}</span>
                      )}
                    </span>

                    <div className="profiledrop-info">
                      <div className="profiledrop-name">{userName}</div>
                      <div className="profiledrop-email">{userEmail}</div>
                    </div>
                  </div>

                  <div className="divider"></div>

                  <div
                    className="profile-item"
                    onClick={() => handleNavClick("/user/edit-profile")}
                  >
                    My Profile
                  </div>

                  <div
                    className="profile-item"
                    onClick={() => handleNavClick("/user/my-plans")}
                  >
                    My Subscription
                  </div>

                  <div
                    className="profile-item"
                    onClick={() => handleNavClick("/user/partner-preference")}
                  >
                    Edit Preference
                  </div>
                  <div
                    className="profile-item"
                    onClick={() => handleNavClick("/user/account-settings")}
                  >
                    Account Settings
                  </div>


                  <div className="profile-item logout" onClick={handleLogout}>
                    Logout
                  </div>
                </div>
              )}
            </div>

            {/* Mobile Menu */}
            <PiListHeart
              className="hamburger"
              size={30}
              onClick={() => setShowMenu(true)}
            />
          </div>
        </Container>
      </header>

      {/* Side Menu */}
      <div className={`side-menu ${showMenu ? "open" : ""}`}>
        <div className="side-header text-white">
          <span></span>
          <span onClick={() => setShowMenu(false)}>
            <LuPanelRightClose size={20} />
          </span>
        </div>

        <div className="d-flex mobile-menucard  flex-column text-start">
          <button
            onClick={() => {
              setShowMenu(false);
              handleNavClick("/user/home");
            }}
            className="mobile-sidenavmenu mx-2 my-2 p-2"
          >
            Home
          </button>

          <button
            onClick={() => {
              setShowMenu(false);
              handleNavClick("/user/message");
            }}
            className="mobile-sidenavmenu mx-2 my-2 p-2"
          >
            Message
          </button>

          <button
            onClick={() => {
              setShowMenu(false);
              handleNavClick("/user/interests");
            }}
            className="mobile-sidenavmenu mx-2 my-2 p-2"
          >
            Interests
          </button>

          <button
            onClick={() => {
              setShowMenu(false);
              handleNavClick("/user/profile-search");
            }}
            className="mobile-sidenavmenu mx-2 my-2 p-2"
          >
            Matches
          </button>

          <button
            onClick={() => {
              setShowMenu(false);
              handleNavClick("/user/membership");
            }}
            className="mobile-sidenavmenu mx-2 my-2 p-2"
          >
            Membership Plans
          </button>
        </div>
      </div>

      {showMenu && (
        <div className="overlay" onClick={() => setShowMenu(false)} />
      )}

      {showBuyPlanModal && (
        <div
          className="modal-overlay"
          onClick={() => dispatch(closeBuyPlanModal())}
        >
          <div
            className="modal-box"
            style={{ maxWidth: 400 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <div className="modal-title">Upgrade Required</div>
            </div>

            <div className="modal-body" style={{ padding: 20 }}>
              <p style={{ fontSize: 14, color: "#555" }}>
                You need an active membership plan to access this feature.
              </p>
            </div>

            <div className="modal-footer">
              <button
                className="modal-btn-next"
                style={{ width: "100%" }}
                onClick={() => {
                  dispatch(closeBuyPlanModal());
                  navigate("/user/membership");
                }}
              >
                Buy Plan →
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
